var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { AccordionItem, Wrapper } from './components/AccordionItem';
import { AccordionProvider } from './components/AccordionProvider';
export const Accordion = (_a) => {
    var { children = null, backgroundColor = 'white' } = _a, rest = __rest(_a, ["children", "backgroundColor"]);
    const [selectedId, setSelectedId] = useState('');
    return (React.createElement(Wrapper, Object.assign({ px: "spacing-s", backgroundColor: backgroundColor, borderRadius: ['m'] }, rest),
        React.createElement(AccordionProvider, { value: {
                selectedId,
                setSelectedId,
            } }, children)));
};
export { AccordionItem };
